module.exports = (__webpack_require__(13))(41);


//////////////////
// WEBPACK FOOTER
// delegated ../static/lib/issue-plugin/bootstrap/js/bootstrap.min.js from dll-reference vendors
// module id = 225
// module chunks = 23